import { inject, injectable } from "inversify";
import {UserSubscriptionData} from '../../data/userSubscriptionData';
import {DocumentTypeData} from '../../data/documentTypeData';
import { AuthorizationsHistoryData } from "../../data/authorizationsHistoryData";
import ISubscriptionService from "./ISubscriptionService";
import { PersonApi } from "../api/PersonApi";
import i18n from "@/i18n";
import IAlertService from "../alert/IAlertService";
import { DiTokens } from "../diTokens";
import IErrorService from "../error/IErrorService";

@injectable()
/** Сервис данных клиента */
export default class SubscriptionService implements ISubscriptionService {
  constructor(
    @inject(DiTokens.AlertService) private alertService: IAlertService,
    @inject(DiTokens.ErrorService) private errorService: IErrorService
  ) {}

  public async fetchSubscription(): Promise<Array<UserSubscriptionData>> {
    try {
      const subs: Array<UserSubscriptionData> = await PersonApi.getUserSubscriptions();
      return subs;
    } catch (e) {
      await this.errorService.errorHandler(e, false, true, i18n.t("main.charges.errors.loadError", { errorText: e.message }).toString());
    }
  }

  public async fetchUserDocumentTypes(): Promise<Array<DocumentTypeData>> {
    try {
      const docTypes: Array<DocumentTypeData> = await PersonApi.getUserDocumentTypes();
      return docTypes;
    } catch (e) {
      await this.errorService.errorHandler(e, false, true, i18n.t("main.charges.errors.loadError", { errorText: e.message }).toString());
    }
  }

  public async deleteSubscription(id: number): Promise<Array<UserSubscriptionData>> {
    try {
      await PersonApi.hideUserSubscriptionAsync(id);
      const subs: Array<UserSubscriptionData> = await this.fetchSubscription();
      this.alertService.success('Подписка успешно удалена');
      return subs;
    } catch (e) {
      await this.errorService.errorHandler(e, false, true, i18n.t("main.charges.errors.loadError", { errorText: e.message }).toString());
    }
  }

}
